import { useTranslation } from "@equiem/web-ng-lib";
import { EscapedHtmlDiv, ProgressCircle, Site } from "@equiem/web-ng-lib";
import React, { useContext } from "react";
import { useLegalContentQuery } from "../../generated/gateway-client";
import { useViewerTokens } from "../../hooks/useViewerTokens";

interface Props {
  type: "terms" | "cookies" | "privacy" | "3rdparty";
}

export const LegalContent: React.FC<Props> = ({ type }) => {
  const { t } = useTranslation();

  const viewerTokens = useViewerTokens();
  const site = useContext(Site);
  const { loading, data } = useLegalContentQuery({ variables: { uuid: site.uuid }});

  if (loading) {
    return <div className="text-center py-3"><ProgressCircle size="lg" /></div>;
  }

  if (data == null || data.destination == null) {
    return <>{t("main.error")}</>;
  }

  let content = data.destination.cookiePolicy;
  if (type === "terms") {
    content = data.destination.termsAndConditions;
  }
  else if (type === "privacy") {
    content = data.destination.privacyPolicy;
  }
  else if (type === "3rdparty") {
    content = data.destination.thirdPartyServiceProviders;
  }

  return <EscapedHtmlDiv className="py-3" html={viewerTokens(content ?? "")} />;
};
